import React, { useEffect, useMemo, useState } from 'react';

export const VERSION_DESCRIPTION_MAX_LENGTH = 200;

const DeployConfirmationModal = ({
  isOpen,
  confirmationText,
  onClose,
  onConfirm,
  title = 'Deployment Confirmation'
}) => {
  const [typedText, setTypedText] = useState('');
  const [versionDescription, setVersionDescription] = useState('');
  const expectedText = useMemo(() => confirmationText || '', [confirmationText]);

  useEffect(() => {
    if (isOpen) {
      setTypedText('');
      setVersionDescription('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const normalizedVersionDescription = versionDescription.trim();
  const hasValidVersionDescription = normalizedVersionDescription.length > 0
    && normalizedVersionDescription.length <= VERSION_DESCRIPTION_MAX_LENGTH;
  const canDeploy = typedText === expectedText && hasValidVersionDescription;

  return (
    <div style={{ zIndex: '9999999999', position: 'fixed', top: 0, left: 0, height: '100%', width: '100%', background: 'rgba(0,0,0, 0.5)' }}>
      <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-lg w-full max-w-lg relative">
          <div className="flex justify-between items-center p-4 pb-2">
            <h2 className="text-lg text-gray-800" style={{ fontWeight: '550' }}>{title}</h2>
          </div>

          <div className="p-6 pt-2 text-sm text-gray-700">
            <label htmlFor="version-description" className="block mb-2 font-medium text-gray-700">
              Version description <span className="text-red-600">*</span>
            </label>
            <textarea
              id="version-description"
              value={versionDescription}
              onChange={(e) => setVersionDescription(e.target.value)}
              placeholder="Describe the changes in this version"
              maxLength={VERSION_DESCRIPTION_MAX_LENGTH}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg resize-none focus:outline-none focus:ring-1 focus:ring-indigo-500"
            />
            <div className="flex justify-between mt-1 mb-4 text-xs text-gray-500">
              <span>Required</span>
              <span>{versionDescription.length}/{VERSION_DESCRIPTION_MAX_LENGTH}</span>
            </div>

            <div className="mb-2">
              <span>Type the below sentence</span>
              <div className="font-semibold">{expectedText}</div>
            </div>
            <input
              type="text"
              value={typedText}
              onChange={(e) => setTypedText(e.target.value)}
              placeholder="Type the exact sentence"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-indigo-500"
            />
          </div>

          <div className="flex justify-end gap-3 p-6 pt-0">
            <button
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-50 focus:outline-none"
              style={{ height: '40px', borderRadius: '4px' }}
            >
              Cancel
            </button>
            <button
              onClick={() => onConfirm(normalizedVersionDescription)}
              disabled={!canDeploy}
              className={`px-4 py-2 text-white rounded focus:outline-none ${canDeploy ? 'bg-indigo-600 hover:bg-indigo-700' : 'bg-gray-500 cursor-not-allowed'}`}
              style={{ height: '40px', borderRadius: '4px' }}
            >
              Deploy
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeployConfirmationModal;
